import useTimeZone from '@src/hooks/useTimeZone';
import './b2chat-logo_style.css';
import B2ChatLogo from './B2ChatLogo';

const CustomB2ChatLogo: React.FC = () => {
  const [isFromAmerica] = useTimeZone();

  return (
    <B2ChatLogo variant={`${isFromAmerica ? 'B2Chat-blue' : 'B2Chat-green'}`} />
  );
};

export default CustomB2ChatLogo;
